import React from 'react'
import { Box, Chip, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'

import useDaiChat from 'hooks/useDaiChat'

import dai from 'constants/dai'

import useStyles from './styles'

const ChatSuggestions = () => {
  const classes = useStyles()
  const { agentName, sendMessage, isSending, registerMixpanelEvent } =
    useDaiChat()

  const items = dai.suggestions.byAgent[agentName]

  if (isEmpty(items)) return null

  const handleClick = (question) => {
    registerMixpanelEvent('click-suggestion')
    sendMessage(question)
  }

  return (
    <Box className={classes.root}>
      <Typography variant="caption" color="textSecondary">
        {dai.suggestions.header}
      </Typography>
      <Box className={classes.chips}>
        {items.map((item) => (
          <Chip
            key={item.label}
            label={item.label}
            variant="outlined"
            clickable
            disabled={isSending}
            onClick={() => handleClick(item.question)}
            className={classes.chip}
          />
        ))}
      </Box>
    </Box>
  )
}

export default ChatSuggestions
